<script setup lang="ts">
const props = withDefaults(defineProps<{
  rows?: number
}>(), {
  rows: 3
})

const rowCount = computed(() => Math.max(1, Math.floor(props.rows || 3)))
</script>

<template>
  <div class="post-skeleton-list" aria-hidden="true">
    <article v-for="idx in rowCount" :key="idx" class="card post-skeleton-card">
      <span class="post-skeleton-meta-line skeleton-block" />
      <div class="post-skeleton-title">
        <span class="post-skeleton-line line-title skeleton-block" />
        <span class="post-skeleton-line line-title-short skeleton-block" />
      </div>
      <div class="post-skeleton-excerpt">
        <span class="post-skeleton-line line-full skeleton-block" />
        <span class="post-skeleton-line line-mid skeleton-block" />
        <span class="post-skeleton-line line-short skeleton-block" />
      </div>
      <div class="post-skeleton-foot">
        <span class="post-skeleton-tags-line skeleton-block" />
        <span class="post-skeleton-more skeleton-block" />
      </div>
    </article>
  </div>
</template>

<style scoped>
.post-skeleton-list {
  --skeleton-bg: color-mix(in srgb, var(--line) 74%, var(--bg) 26%);
  --skeleton-glow: color-mix(in srgb, var(--bg) 70%, var(--skeleton-bg) 30%);
  display: grid;
  gap: 18px;
}

.post-skeleton-card {
  padding: 18px;
  display: grid;
  gap: 14px;
}

.post-skeleton-meta-line {
  width: min(100%, 360px);
  height: 12px;
  border-radius: 999px;
}

.post-skeleton-title {
  display: grid;
  gap: 8px;
}

.post-skeleton-line {
  height: 14px;
  border-radius: 999px;
}

.line-title {
  width: 92%;
  height: 20px;
}

.line-title-short {
  width: 62%;
  height: 20px;
}

.post-skeleton-excerpt {
  display: grid;
  gap: 8px;
}

.line-full {
  width: 100%;
}

.line-mid {
  width: 84%;
}

.line-short {
  width: 65%;
}

.post-skeleton-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.post-skeleton-tags-line {
  width: min(100%, 150px);
  height: 24px;
  border-radius: 999px;
}

.post-skeleton-more {
  width: 82px;
  height: 14px;
  border-radius: 999px;
}

.skeleton-block {
  position: relative;
  overflow: hidden;
  background: var(--skeleton-bg);
}

.skeleton-block::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(100deg, transparent 16%, var(--skeleton-glow) 50%, transparent 84%);
  animation: skeleton-shimmer 1.8s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-block::after {
    animation: none;
  }
}
</style>
